import { render, staticRenderFns } from "./FamilyMemberList.vue?vue&type=template&id=a53edffe&scoped=true"
import script from "./FamilyMemberList.vue?vue&type=script&lang=js"
export * from "./FamilyMemberList.vue?vue&type=script&lang=js"
import style0 from "./FamilyMemberList.vue?vue&type=style&index=0&id=a53edffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53edffe",
  null
  
)

export default component.exports